import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ isAuthenticated, isSuperAdmin = false, requiredPermission = null, children, permissions = [] }) => {
    // Not authenticated - redirect to login
    if (!isAuthenticated) {
        return <Navigate to="/sign-in" replace />;
    }

    // Super admin always has access
    if (isSuperAdmin) {
        return children;
    }

    // Check specific permissions
    if (requiredPermission && !permissions.includes(requiredPermission)) {
        return <Navigate to="/admin/unauthorized" replace />;
    }

    return children;
};

export default ProtectedRoute;
